import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const HeaderSection = () => {
  return (
    <BusinessHero
      title="Online-Shops, die verkaufen"
      titleHighlight="E-Commerce-Entwicklung"
      description="Wir entwickeln Online-Shops und E-Commerce-Plattformen - von B2C-Shops über B2B-Portale bis hin zu Multi-Channel-Strategien mit Amazon, eBay und Co."
      details="Ob Shopware-Shop, individuelle E-Commerce-Plattform oder komplexe B2B-Portale für Franchise-Systeme - wir begleiten dich vom Konzept bis zum erfolgreichen Online-Vertrieb. Inklusive SEA-Marketing und Anbindung aller wichtigen Sales-Channels."
      backgroundStyle="silver"
      primaryCTA={{
        label: "E-Commerce Lösungen entdecken",
        href: "#ecommerce-features"
      }}
      secondaryCTA={{
        label: "Beratungsgespräch vereinbaren",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default HeaderSection; 